<template>
  <transition name="modal" v-if="showModal">
    <div class="modal-mask" @click.self="closeModaler">
      <div class="modal-wrapper">
        <div class="modal-container">
						<div class="modal__close" @click="closeModaler"></div>
            <slot name="content">
              default modal Content please fill
            </slot>
        	
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
	export default {
		data(){
			return {
				// showModal : true
			}
		},
		methods : {
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}
		},
		computed : {
			showModal(){
				
				return this.$store.getters.getModalActive.modalActive
				
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/BaseModal.vue